$(document).ready(function() {

  if ( $(window).width() > 768 ) {

    $('.cart-popover').popover({
      html: true,
      container: 'body',
      placement: 'bottom',
      trigger: 'manual'
    });

    if ( $('.cart-popover.start-open').length ) {
      showHideCart( $('.main-header .cart-wrapper:visible .cart-popover.start-open') );
    }

    // open mini cart when hovering the cart icon
    $('.icon-cart').on('mouseenter', function() {
      showHideCart( $(this).closest('.cart-wrapper').find('.cart-popover') );
    });

    // close the mini cart when mouse lieaving the popover or the icon list
    $(".icons-menu .list-inline").on('mouseleave', function() {
      if (!$(".popover:hover").length) {
        showHideCart( $(this).find('.cart-popover'), true );
      }
    });
    $('.cart-popover').on('mouseleave', function() {
      showHideCart( $(this), true );
    });

    // Cart content scroll without scrolling page
    $('.cart-popover .popover-content').on('mouseover', function() {
      if ($(this).height() > 250) {
        $('body').css('overflow', 'hidden');
      }
    }).on('mouseout', function() {
      $('body').css('overflow', 'auto');
    });

  }

});

function showHideCart( $cart, hide ){
  if ( $cart.length ) {
    if ( hide ) {
      $cart.removeClass('cart-visible');
      setTimeout(function() {
        $cart.hide();
      }, 200);
    } else {
      $cart.show();
      $cart.addClass('cart-visible');
/*      setTimeout(function() {
        // scroll the div to the bottom when showing the cart. 
        // So the user always see the last product added to the cart
        var $d = $cart.find('.cart_lis2ft');
        $d.scrollTop( $d.prop("scrollHeight") );
      }, 10);*/
    }
  }
}
